// import persistReducer from "redux-persist/lib/persistReducer";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/lib/storage";
import { VendorConstant } from "./vendorConstant";


const initialState = {
    

    VendorCityList: [{}],
    VendorsCity: {

        isLoading: true,

    },

    VendorRequestList: [{}],
    VendorsRequest: {

     isLoading: true,


 },

 VendorCountList: [],
 reqCount: '',




 //post
  ApproveEnableDisableList: [],
        ApproveEnableTable: {

        isLoading: true,


    },
 //post vendor enable disable
 VendorEnableDisableList: [],
 VendorEnableTable: {

        isLoading: true,


    },

};

export const VendorReducers = persistReducer(
    {
        storage,
        key: "Vendors",
        whitelist: [],
    },
    (state = initialState, { type, payload }) => {
        switch (type) {

            case VendorConstant.VENDOR_CITY_REQUEST: {
                return {
                    ...state,
                    VendorCityList: [],
                    VendorsCity: {

                        isLoading: true,


                    },
                };
            }
            case VendorConstant.VENDOR_CITY_RESPONSE: {

                return {
                    ...state,
                    VendorCityList: payload,
                    VendorsCity: {

                        isLoading: false,


                    },
                };
            }

            case VendorConstant.VENDOR_SEEALLRES_REQUEST: {
                return {
                    ...state,
                    VendorRequestList: [],
                    VendorsRequest: {

                        isLoading: true,


                    },
                };
            }
            case VendorConstant.VENDOR_SEEALLRES_RESPONSE: {

                return {
                    ...state,
                    VendorRequestList: payload,
                    VendorsRequest: {

                        isLoading: false,


                    },
                };
            }




            case VendorConstant.VENDOR_COUNT_REQUEST: {
                return {
                    ...state,
                    VendorCountList: [],
                    VendorsCount: {

                        isLoading: true,


                    },
                };
            }
            case VendorConstant.VENDOR_COUNT_RESPONSE: {

                return {
                    ...state,
                    VendorCountList: payload,
                    reqCount: payload.result.pending_vendors,

                    VendorsCount: {

                        isLoading: false,


                    },
                };
            }

// approve enable desable reducer

case VendorConstant.APPROVE_ENABLE_DISABLE_REQUEST:{

    return {
        ...state,
        ApproveEnableDisableList: [],
        ApproveEnableTable: {

        isLoading: true,


    },
    };
}

case VendorConstant.APPROVE_ENABLE_DISABLE_RESPONSE: {
    
    return {
        ...state,
        ApproveEnableDisableList: payload,
        ApproveEnableTable: {

        isLoading: false,
            

    },
    };
}

// vendor enable desable reducer

case VendorConstant.VENDOR_ENABLE_DISABLE_REQUEST:{

    return {
        ...state,
        VendorEnableDisableList: [],
        VendorEnableTable: {

        isLoading: true,


    },
    };
}

case VendorConstant.VENDOR_ENABLE_DISABLE_RESPONSE: {
    
    return {
        ...state,
        VendorEnableDisableList: payload,
        VendorEnableTable: {

        isLoading: false,
            

    },
    };
}






            default:
                return state;
        }
    }
);
